import { useCallback, useMemo, useRef, useState } from "react";
import { type ListProps } from "./types";

import listStyle from './List.module.scss';

import { Responsive, useIsMobile } from "../Responsive";

import Pagination from "./Pagination/Pagination";
import { HeaderContainer } from "./components/HeaderContainer/HeaderContainer";
import { ContextMenu, PresentOptions } from "./components/Menu/Menu";
import { RowContainer } from "./components/RowContainer/RowContainer";




function List<T extends string = string, TObject extends Record<string, any> = Record<string, any>>({
    headers,
    rows,
    sliderChildren,
    sort,
    link,
    maxHeight,
    style,
    pageSize,
    currentPage,
    numberOfPages,
    totalCountOfItems,
    onMenu,
    onPageChange,
    onPageSize,
    onReload,
    onSort,
    onPopupResize,
    changeMenuHeightAtPercent,
    noPagination = false,
    noLink = false,
    rowClass = "",
    rowContainerClass = "",
    ableSwitchContextDirection = true,
    onClick,
}: ListProps<T, TObject>)
{
    const mobileView = useIsMobile();

    const flipDirectionPercent = changeMenuHeightAtPercent || 50;

    if (!maxHeight) maxHeight = mobileView ? "86vh" : "47vh";

    const [presentOption, setPresentOption] = useState<PresentOptions | null>(null);


    const onDismiss = useCallback(() =>
    {
        setPresentOption(prev => null);
    }, []);

    const onRowContainerMenu = useCallback((id: string, event: any, routeParams: Record<string, any>) => setPresentOption(() => ({ id, event, routeParams })), []);

    const hasMenu = useRef<boolean>(Boolean(onMenu));


    const Rows = useMemo(() =>
    {
        return <RowContainer
            sliderChildren={sliderChildren}
            link={link}
            rowClass={rowClass}
            rowContainerClass={rowContainerClass}
            noLink={noLink}
            headers={headers}
            rows={rows}
            hasMenu={hasMenu.current}
            //elementRef={(ref) => ref && setReady(true)}
            onMenu={onRowContainerMenu}
        />;
    }, [headers, link, noLink, onRowContainerMenu, rowClass, rowContainerClass, rows, sliderChildren]);


    const ListContextMenu = useMemo(() =>
        <ContextMenu
            flipDirectionPercent={flipDirectionPercent}
            ableSwitchContextDirection={ableSwitchContextDirection}
            presentOption={presentOption}
            onDismiss={onDismiss}
            onMenu={onMenu}
        />
        , [ableSwitchContextDirection, flipDirectionPercent, onDismiss, onMenu, presentOption]);

    return (
        <div style={style} className={`${listStyle.list}`}>
            {ListContextMenu}
            <Responsive desktop>
                <div className={`${listStyle.row} ${listStyle.header}`}>
                    <HeaderContainer headers={headers} onSort={onSort} sort={sort} hasMenu={hasMenu.current} />
                </div>
            </Responsive>

            {Rows}
            {!noPagination ? <Pagination
                pageSize={pageSize}
                currentPage={currentPage}
                numberOfPages={numberOfPages}
                totalCountOfItems={totalCountOfItems}
                onPageChange={(page) =>
                {
                    onPageChange && onPageChange(page);
                }}
                onPageSize={onPageSize}
                onReload={onReload}
            /> : null}
        </div >
    );
};

export default List;
